var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCancelWhite = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4438 1.34233L1.37764 11.4792C1.15438 11.7025 1.00235 11.9787 0.954989 12.247C0.907629 12.5154 0.968819 12.754 1.1251 12.9103C1.28138 13.0665 1.51995 13.1277 1.78832 13.0804C2.0567 13.033 2.33289 12.881 2.55615 12.6577L12.6223 2.52084C12.8456 2.29758 12.9976 2.02138 13.045 1.75301C13.0923 1.48464 13.0311 1.24607 12.8749 1.08979C12.7186 0.933507 12.48 0.872316 12.2116 0.919676C11.9433 0.967037 11.6671 1.11907 11.4438 1.34233Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6577 11.4438L2.52079 1.37764C2.29754 1.15438 2.02134 1.00235 1.75297 0.954989C1.48459 0.907629 1.24602 0.968819 1.08974 1.1251C0.933464 1.28138 0.872273 1.51995 0.919634 1.78832C0.966994 2.0567 1.11902 2.33289 1.34228 2.55615L11.4792 12.6223C11.7024 12.8456 11.9786 12.9976 12.247 13.045C12.5154 13.0923 12.7539 13.0311 12.9102 12.8749C13.0665 12.7186 13.1277 12.48 13.0803 12.2116C13.033 11.9433 12.8809 11.6671 12.6577 11.4438Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCancelWhite);
export default ForwardRef;